import { Promise } from "core-js";
import 'isomorphic-fetch';

let promisfyBaseRequest = settings => {
  let xhr = new XMLHttpRequest()
  promisify(xhr);
  xhr.open(settings.method, settings.url)
  xhr.setRequestHeader('Content-Type', 'application/json');
  if (settings.headers) {
    Object.keys(settings.headers).forEach(key => {
      xhr.setRequestHeader(key, settings.headers[key]);
    });
  }

  return xhr.send(JSON.stringify(settings.data));
}

let sendRequest = settings => {
  settings.async = false;
  return promisfyBaseRequest(settings);
}

function promisify(xhr) {
  const oldSend = xhr.send;
  xhr.send = function () {
    const xhrArguments = arguments;
    return new Promise(function (resolve, reject) {
      // Note that when we call reject, we pass an object
      // with the request as a property. This makes it easy for
      // catch blocks to distinguish errors arising here
      // from errors arising elsewhere. Suggestions on a 
      // cleaner way to allow that are welcome.
      xhr.onload = function () {
        var response = JSON.parse(xhr.responseText);
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          if (response.code && response.code !== '0001') {
            resolve(response);
          } else {
            reject(response);
          }
        } else {
          reject(response)
        }
      };
      xhr.onerror = function () {
        reject(JSON.parse(xhr.responseText));
      };
      oldSend.apply(xhr, xhrArguments);
    });
  }
}

module.exports = {
  post: function (url, data, headers) {
    let settings = {
      method: 'POST',
      url: url,
      data: data,
      headers: headers,
      async: false
    }

    return sendRequest(settings);
  },
  get: function (url, data, headers) {
    let settings = {
      method: 'GET',
      url: url,
      data: data,
      headers: headers,
      async: false
    }

    return sendRequest(settings);
  },
  fetchGet: function (url, headers) {
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: headers,
    })
  }

}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/core/service.js